<template>
  <div class="banner">
    <div class="container p-l-30 p-r-30">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-8">
          <div class="banner-text pb-0">
            
            <h4>Say Hello to <br /> Angel Communities</h4>

            <router-link to="/authentication/login"
              class="btn btn-outline-gradient btn-lg btn-mw text-uppercase d-inline-block d-sm-none mr-1 minw-sm-unset campaign-btn-50">Login</router-link>
            <router-link to="/authentication/register"
              class="btn btn-gradient btn-lg btn-mw text-uppercase minw-sm-unset campaign-btn-50">Register
              Now</router-link>
          </div>
        </div>
      </div>
    </div>
    <img class="banner-img" src="@/assets/images/home_image/banner-standapp.svg" alt="angel-communities-banner" loading="lazy">
  </div>
</template>
<script>
export default {
  name: "BannerSection",
  data() {
    return {
      show_banner: false,
      welcome_messages: {
        banner_li: [
          'Google Forms',
          'Eventbrite',
          'GoFundMe',
        ],
      },
    };
  },
};
</script>